import React from 'react';

import {
  SectionContainer,
  ContentWrapper,
  DriverInfoContainer,
  DriverInfoWrapper,
  InfoTitle,
} from '../styles';

const RecipientSection = ({ recipientInfo }) => (
  <SectionContainer>
    <ContentWrapper bordered backgroundColor="white">
      <DriverInfoContainer>
        <DriverInfoWrapper>
          <InfoTitle color="#263465">
            Destinatário
          </InfoTitle>
          <InfoTitle minHeght={32} color="#292F36" medium>
            {recipientInfo.destination.name}
          </InfoTitle>
        </DriverInfoWrapper>
        <DriverInfoWrapper>
          <InfoTitle color="#263465">
            Código do destinatário
          </InfoTitle>
          <InfoTitle color="#292F36" medium>
            {recipientInfo.cnpjDest}
          </InfoTitle>
        </DriverInfoWrapper>
      </DriverInfoContainer>
    </ContentWrapper>
  </SectionContainer>
);

export default RecipientSection;
